/** The server's own sentence for a refused version write (SA-1410): a 409
 * `version_number_taken` reads "Another version of this workflow was
 * published at the same moment. Try again." Null when the error is not an
 * `ApiError` whose detail carries a non-empty `message`, so the caller keeps
 * its own words. */
import { ApiError } from '@/services/apiClient'

export function refusalMessage(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null
  const d = error.detail
  if (!d || typeof d !== 'object') return null
  const message = (d as { message?: unknown }).message
  return typeof message === 'string' && message.trim() !== '' ? message : null
}
